<template>
  <div
    id="main-grid"
    class="grid simple main borderRadius4px"
    style="background: #e5e9ec"
  >
    <div style="background: #e5e9ec">
      <!-- form -->
      <div
        class="grid-body no-border borderBottom"
        style="padding-left: 0px !important; padding-bottom: 0px !important;"
      >
        <h6>{{ i18nValues["productionEstimate"] }}</h6>
        <el-form
          v-loading="loading != 0"
          ref="productionEstimateForm"
          :model="productionEstimate"
          :rules="rules"
        >
          <div class="input-container d-flex align-items-center">
            <!-- initialProductionEstimate -->
            <el-form-item prop="initialProductionEstimate">
              <template v-if="mode !== 'view'">
                <el-input
                  v-model="productionEstimate.initialProductionEstimate"
                  type="number"
                  step="any"
                  :placeholder="i18nValues['initialProductionEstimate']"
                  v-on:input="calculate()"
                  style="width: 250px;"
                ></el-input>
              </template>
            </el-form-item>

            <!-- estimateHarvest -->
            <el-form-item prop="estimateHarvest">
              <template v-if="mode !== 'view'">
                <el-input
                  v-model="productionEstimate.estimateHarvest"
                  :placeholder="i18nValues['estiamteHarvestQty']"
                  disabled
                  style="width: 250px; padding: 10px;"
                ></el-input>
              </template>
            </el-form-item>

            <!-- add button  -->
            <el-form-item>
              <template v-if="mode !== 'view'">
                <el-button
                  v-if="!isEditing"
                  @click="add()"
                  icon="fas fa-plus"
                  id="addButton"
                  size="small"
                  class="btn-primary"
                >
                  {{ i18nValues["add"] }}
                </el-button>
              </template>
            </el-form-item>
            <!-- save button  -->
            <el-form-item>
              <el-button
                v-if="isEditing"
                @click="save()"
                icon="fas fa-check"
                id="saveButton"
                size="small"
                class="btn-primary"
              >
                {{ i18nValues["save"] }}
              </el-button>
            </el-form-item>

            <div></div>

            <!-- cancel button  -->
            <el-form-item>
              <el-button
                v-if="isEditing"
                @click="cancel()"
                id="cancelButton"
                size="small"
                icon="fas fa-times"
                class="btn-cancel"
              >
                {{ i18nValues["cancel"] }}
              </el-button>
            </el-form-item>
          </div>

          <!-- table -->
          <el-form-item prop="productionEstimates">
            <div class="table-container">
              <el-table
                :data="ProductionEstimateSubList"
                class="table table-hover table-striped"
                id="ProductionEstimateTable"
                :empty-text="i18nValues['noDataAvailable']"
                align="center"
              >
                <!-- ProductionEstimate Date -->
                <el-table-column
                  prop="date"
                  :label="i18nValues['date']"
                  :formatter="formatDateProductionEstimate"
                  width="25"
                  align="center"
                ></el-table-column>

                <!-- ProductionEstimate InitialEstimate -->
                <el-table-column
                  prop="initialProductionEstimate"
                  :label="i18nValues['initialProductionEstimate']"
                  width="25"
                  align="right"
                ></el-table-column>

                <!-- ProductionEstimate Estimate Harvest -->
                <el-table-column
                  prop="estimateHarvest"
                  :label="i18nValues['estiamteHarvestQty']"
                  :formatter="formatDecimal"
                  width="25"
                  align="right"
                ></el-table-column>

                <!-- ProductionEstimate Estimated Yield -->
                <el-table-column
                  prop="estimatedYield"
                  :label="i18nValues['estimatedYield']"
                  :formatter="formatDecimal"
                  width="25"
                  align="right"
                ></el-table-column>

                <!-- ProductionEstimate Bushel-->
                <el-table-column
                  prop="bushel"
                  :label="i18nValues['bushel']"
                  :formatter="formatDecimal"
                  width="25"
                  align="right"
                ></el-table-column>

                <!-- EDIT/DELETE -->
                <el-table-column width="10" align="right">
                  <template slot-scope="scope" v-if="mode !== 'view'">
                    <el-button
                      class="text-info"
                      icon="fas fa-edit"
                      size="small"
                      :title="i18nValues['edit']"
                      @click="edit(scope.row)"
                    ></el-button>

                    <el-button
                      class="text-danger"
                      icon="fas fa-times"
                      size="small"
                      :title="i18nValues['remove']"
                      @click="deleteProductionEstimate(scope.row)"
                    ></el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div v-if="90 > 10" style="height: 15px"></div>
              <PaginationFunctional
                sublistName="ProductionEstimateSubList"
                :fullList="productionEstimateList"
                :tableSize="15"
                @paginationChange="paginationChange"
              />
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { sync, get } from "vuex-pathify"; // eslint-disable-line no-unused-vars
import PaginationFunctional from "@/components/PaginationFunctional.vue";

const PRODUCTION_ESTIMATE_TABLE_SIZE = 15;
const createEmptyProductionEstimate = () => ({
  initialProductionEstimate: null,
  estimateHarvest: 0,
  estimatedYield: 0,
  bushel: 0,
  date: null,
});
export default {
  name: "ProductionEstimate",
  created() {
    if (this.cropProduction && this.cropProduction.id != 0) {
      this.retrieveProductionEstimateList();
    }
    console.log(this.cropProduction); //eslint-disable-line no-console
  },

  components: {
    PaginationFunctional,
  },

  computed: {
    loading: get("campaign/loading"),
  },

  props: {
    componentsMap: {},
    cropProduction: Object,
    mode: String,
  },

  data() {
    return {
      productionEstimate: createEmptyProductionEstimate(),
      productionEstimateList: [],
      ProductionEstimateSubList: [],
      isEditing: false,
      editingIndex: -1,
      rules: {
        initialProductionEstimate: [
          {
            required: true,
            message: this.i18nValues["requiredValue"] || "Required value",
            trigger: "blur",
          },
          {
            required: true,
            message: this.i18nValues["requiredValue"] || "Required value",
            trigger: "change",
          },
        ],
      },
    };
  },

  watch: {
    cropProduction: {
      handler() {
        this.retrieveProductionEstimateList();
      },
      deep: true,
    },
    // "productionEstimate.initialProductionEstimate": {
    // handler() {
    //   this.calculate();
    // },
    // deep: true,
    //},
  },

  methods: {
    add() {
      const form = this.$refs.productionEstimateForm;
      if (!form) {
        return;
      }
      form.validate((valid) => {
        if (!valid) {
          this.notifyError(
            "cantSaveProductionEstimate",
            this.i18nValues["invalidProductionEstimate"] ||
              "Please review the production estimate fields."
          );
          return;
        }
        try {
          this.productionEstimate.date = new Date();
          this.calculate();
          this.productionEstimateList.push({
            ...this.productionEstimate,
          });
          this.syncProductionEstimates();
          this.refreshPaginatedData();
          this.updateCropProductionSummaryFromLastEstimate();
          this.notifySuccess(
            "productionEstimateSaved",
            this.i18nValues["productionEstimateSaved"] ||
              "Production estimate saved."
          );
          this.resetFormState();
        } catch (error) {
          this.notifyError(
            "cantSaveProductionEstimate",
            this.i18nValues["cantSaveProductionEstimate"] ||
              "We couldn't save the production estimate."
          );
        }
      });
    },

    // changeYieldAndBushel(){
    //   this.cropProduction.estimatedYield = (this.cropProduction.productionPerformanceEstimate / 1000) / 0.06725;
    //   this.cropProduction.estimatedYield = Math.round(this.cropProduction.estimatedYield * 100) / 100;
    //   this.cropProduction.bushel = this.cropProduction.qtyEstimateHarvest / 27,2183;
    //   this.cropProduction.bushel = Math.round(this.cropProduction.bushel * 100) / 100;
    //   this.productionEstimate = {};
    // },

    calculate() {
      if (this.productionEstimate.initialProductionEstimate != null) {
        this.productionEstimate.estimateHarvest =
          this.productionEstimate.initialProductionEstimate *
          this.cropProduction.has;
        this.productionEstimate.estimateHarvest = this.productionEstimate.estimateHarvest.toFixed(
          2
        );
        this.productionEstimate.estimatedYield =
          this.productionEstimate.initialProductionEstimate / 1000 / 0.06725;
        this.productionEstimate.estimatedYield = this.productionEstimate.estimatedYield.toFixed(
          2
        );
        this.productionEstimate.bushel =
          this.productionEstimate.estimateHarvest / 27.2183;
      }
      // this.cropProduction.productionPerformanceEstimate = this.productionEstimate.initialProductionEstimate;
      // this.cropProduction.qtyEstimateHarvest = this.productionEstimate.estimateHarvest;
    },

    retrieveProductionEstimateList() {
      if (
        this.cropProduction &&
        Array.isArray(this.cropProduction.productionEstimates)
      ) {
        this.productionEstimateList = this.cropProduction.productionEstimates;
      } else {
        this.productionEstimateList = [];
        this.syncProductionEstimates();
      }
      this.refreshPaginatedData();
    },

    deleteProductionEstimate(row) {
      this.$confirm(
        this.i18nValues["deleteEstimationMessage"],
        this.i18nValues["deleteEstimation"],
        {
          distinguishCancelAndClose: true,
          confirmButtonText: "Eliminar",
          cancelButtonText: "Cancelar",
          type: "warning",
        }
      )
        .then(() => {
          const index = this.productionEstimateList.indexOf(row);
          if (index > -1) {
            this.productionEstimateList.splice(index, 1);
            this.syncProductionEstimates();
            this.refreshPaginatedData();
            this.updateCropProductionSummaryFromLastEstimate();
            this.notifySuccess(
              "productionEstimateDeleted",
              this.i18nValues["productionEstimateDeleted"] ||
                "Production estimate removed."
            );
          }
        })
        .catch(() => {
          // Intentional no-op; user cancelled the confirmation dialog.
        });
    },

    edit(row) {
      this.isEditing = true;
      this.editingIndex = this.productionEstimateList.indexOf(row);
      this.productionEstimate = {
        ...row,
      };
      this.$nextTick(() => {
        if (this.$refs.productionEstimateForm) {
          this.$refs.productionEstimateForm.clearValidate();
        }
      });
    },

    save() {
      const form = this.$refs.productionEstimateForm;
      if (!form) {
        return;
      }
      form.validate((valid) => {
        if (!valid) {
          this.notifyError(
            "cantSaveProductionEstimate",
            this.i18nValues["invalidProductionEstimate"] ||
              "Please review the production estimate fields."
          );
          return;
        }
        if (this.editingIndex < 0) {
          this.notifyError(
            "cantSaveProductionEstimate",
            this.i18nValues["noProductionEstimateSelected"] ||
              "No production estimate selected."
          );
          return;
        }
        this.productionEstimateList.splice(this.editingIndex, 1, {
          ...this.productionEstimate,
        });
        this.syncProductionEstimates();
        this.refreshPaginatedData();
        this.updateCropProductionSummaryFromLastEstimate();
        this.notifySuccess(
          "productionEstimateUpdated",
          this.i18nValues["productionEstimateUpdated"] ||
            "Production estimate updated."
        );
        this.resetFormState();
      });
    },

    cancel() {
      this.resetFormState();
    },

    refreshPaginatedData() {
      const list = Array.isArray(this.productionEstimateList)
        ? this.productionEstimateList
        : [];
      const firstPage = list.slice(0, PRODUCTION_ESTIMATE_TABLE_SIZE);
      if (typeof this.paginationChange === "function") {
        this.paginationChange({
          sublistName: "ProductionEstimateSubList",
          list: firstPage,
        });
      } else {
        this.ProductionEstimateSubList = firstPage;
      }
    },

    syncProductionEstimates() {
      if (!this.cropProduction) {
        return;
      }
      if (this.cropProduction.productionEstimates !== this.productionEstimateList) {
        this.cropProduction.productionEstimates = this.productionEstimateList;
      }
    },

    resetFormState() {
      this.productionEstimate = createEmptyProductionEstimate();
      this.isEditing = false;
      this.editingIndex = -1;
      if (this.$refs.productionEstimateForm) {
        this.$nextTick(() => {
          if (this.$refs.productionEstimateForm) {
            this.$refs.productionEstimateForm.resetFields();
            this.$refs.productionEstimateForm.clearValidate();
          }
        });
      }
    },

    notify(type, messageKey, fallback) {
      if (!this.$notify || !this.$notify[type]) {
        return;
      }
      const titleKey = type === "success" ? "succes" : "error";
      const resolvedFallback =
        fallback ||
        (type === "success"
          ? "Operation completed successfully."
          : "An unexpected error occurred.");
      this.$notify[type]({
        title:
          (this.i18nValues && this.i18nValues[titleKey]) ||
          (type === "success" ? "Success" : "Error"),
        message:
          (messageKey && this.i18nValues && this.i18nValues[messageKey]) ||
          resolvedFallback,
        position: "bottom-right",
      });
    },

    notifySuccess(messageKey, fallback) {
      this.notify("success", messageKey, fallback);
    },

    notifyError(messageKey, fallback) {
      this.notify("error", messageKey, fallback);
    },

    updateCropProductionSummaryFromLastEstimate() {
      if (!this.cropProduction) {
        return;
      }
      if (!this.productionEstimateList.length) {
        this.cropProduction.productionPerformanceEstimate = null;
        this.cropProduction.qtyEstimateHarvest = null;
        return;
      }
      const lastEstimate = this.productionEstimateList[
        this.productionEstimateList.length - 1
      ];
      if (lastEstimate) {
        this.cropProduction.productionPerformanceEstimate =
          lastEstimate.initialProductionEstimate;
        this.cropProduction.qtyEstimateHarvest = lastEstimate.estimateHarvest;
      }
    },

    formatDateProductionEstimate(row) {
      return this.formatDate(row.date);
    },

    formatDecimal(row, column, cellValue) {
      return new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(cellValue);
    },

    validateNumber() {
      this.productionEstimate.initialProductionEstimate = this.productionEstimate.initialProductionEstimate.replace(
        /\D/g,
        ""
      );
    },
  },
};
</script>

<style scoped>
.input-container {
  align-items: center;
}

.table-container {
  margin-left: 0;
}
</style>
